
import {
	DBxEvent
} from "cartovista";
import ZoomLayeringServer from "cartovistaExtend/layers/ZoomLayeringServer";
import {createLayer, createThemeSetElement, _loadLayersData, _loadEsriLayersData, _loadCartovistaLayersData } from "cartovistaExtend/utils/CvUtils";

    export function loadData() {
        return Promise.all([_loadLayersData(_.filter(C.LAYERS, {LOADING_MODE : "INITIAL"})), _loadEsriLayersData(_.filter(C.LAYERS, {LOADING_MODE : "ESRI"})), _loadCartovistaLayersData(_.filter(C.LAYERS, {LOADING_MODE : "CARTOVISTA"}))]).then(function(responses) {
                return responses;
            }).then(function(response) {
                window.cartovista.dispatchEvent(new DBxEvent("ServerDataInitialized"));
            });
    };

    export function createLayers() {
        var map = window.cartovista.getMap(C.MAP.ID);
        _.forEach(C.LAYERS, function(layerConfig) {
            var layer = createLayer(layerConfig),
                index = typeof layerConfig.INDEX != "undefined" ? layerConfig.INDEX : map.layers.length;
            map.addLayerAt(layer, index);
            window.cartovista.dispatchEvent(new DBxEvent(layerConfig.LAYER_ID + "_layerCreated", {"layer": layer}));
        });
    };

    export function createThemeSetsElements() {
        var map = window.cartovista.getMap(C.MAP.ID),
            themeSetsElements = _.map(C.THEMESETS_ELEMENTS, createThemeSetElement);
        map.addThemeSetElement(themeSetsElements);
    };

    export function initZoomLayeringLayers() {
        var zlLayersConfigs = _.filter(C.LAYERS, "ZOOM_LAYERING");
        _.forEach(zlLayersConfigs, function(layerConfig) {
            new ZoomLayeringServer(layerConfig);
        });
    };